import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Box, Grid, Paper } from "@mui/material";

import MainMenu from "../../components/MainMenu";
import CreateSMP from "./CreateSMP";
import SMPTitleBar from "../../components/SMP/SMPTitleBar";
import PlayerListSMP from "./PlayerList";

import { getSmpList } from "../../redux/actions/smp-action/get-smp-list";
import { getSelectedLeague } from "../../redux/actions/smp-action/get-selected-league";

const Smp = () => {
  const dispatch = useDispatch();
  const [leagueId, setLeagueId] = useState(null);
  const [toggleUpdateSMP, setToggleUpdateSMP] = useState(false);

  const smpListSelector = useSelector((state) => state.getSmpListReducer);
  const selectedSmpSelector = useSelector(
    (state) => state.getSelectedLeagueReducer
  );

  const noOfPlayers = selectedSmpSelector?.status?.leageData
    ? selectedSmpSelector?.status?.leageData[0]?.season_description
        ?.no_of_players
    : 0;

  const handleLeagueId = (value) => setLeagueId(value);

  useEffect(() => {
    dispatch(getSmpList());
  }, []);

  useEffect(() => {
    if (leagueId != null) dispatch(getSelectedLeague(leagueId));
  }, [leagueId, dispatch]);

  useEffect(() => {
    if (
      !smpListSelector.loading &&
      smpListSelector.status?.leagues != undefined
    ) {
      setLeagueId(smpListSelector.status?.leagues[0]?._id);
    }
  }, [smpListSelector]);

  // util func for Make a Round list by given number of players
  const makeRounds = (n) => {
    let arr = [];
    let i = n;

    while (i >= 1) {
      switch (i) {
        case 8:
          arr.push({ rounds: Math.ceil(i), label: "Quarter - Finals" });
          break;

        case 4:
          arr.push({ rounds: Math.ceil(i), label: "Semi - Finals" });
          break;

        case 2:
          arr.push({ rounds: Math.ceil(i), label: "Finals" });
          break;

        case 1:
          arr.push({ rounds: Math.ceil(i), label: "Winner" });
          break;

        default:
          arr.push({ rounds: Math.ceil(i), label: `Round of ${Math.ceil(i)}` });
          break;
      }

      i /= 2;
    }

    return arr;
  };

  const roundsList = makeRounds(noOfPlayers);

  return (
    <MainMenu>
      {!selectedSmpSelector?.loading &&
      !selectedSmpSelector?.error &&
      selectedSmpSelector?.status?.message ? (
        <></>
      ) : (
        <Grid container>
          <Grid item xs={12}>
            <Paper elevation={3} sx={{ padding: "1em" }}>
              <SMPTitleBar
                name="Single Match Play"
                handleToggle={() => setToggleUpdateSMP((prev) => !prev)}
                leagueId={leagueId}
                handleLeagueId={handleLeagueId}
                toggleUpdateSMP={toggleUpdateSMP}
              />

              {!toggleUpdateSMP ? (
                <Box>
                  <PlayerListSMP
                    roundsList={roundsList}
                    noOfPlayers={noOfPlayers}
                    leagueId={leagueId}
                  />
                </Box>
              ) : (
                <CreateSMP setToggleUpdateSMP={setToggleUpdateSMP} />
              )}
            </Paper>
          </Grid>
        </Grid>
      )}
    </MainMenu>
  );
};

export default Smp;
